import React from 'react';
const tel=phone=>{const d=String(phone||'').replace(/\D/g,'');return d?`tel:+${d.length===10?'1'+d:d}`:'';};
export default function PersonHeader({person,button}){
  return <div className="pub-person-main">
    <div><div className="pub-name">{person.name}</div><div className="pub-small">{person.rank}</div><div className="pub-badges"><span className="pub-badge">{person.qualification}</span><span className={`pub-badge ${person.trainee?'warn':'good'}`}>{person.trainee?'Trainee':'Actual'}</span>{person.deployedLabel&&<span className="pub-badge">{person.deployedLabel}</span>}</div></div>
    <div><span className="pub-field">Phone</span>{person.phone?<a href={tel(person.phone)}>{person.phone}</a>:'—'}</div>
    <div><span className="pub-field">Last Deployment</span>{person.lastDeployment||'—'}</div>
    {button||<div><span className="pub-field">Status</span>{person.deployedLabel||'Available'}</div>}
  </div>;
}
